import CloseBig from 'assets/icons/CloseBig';
import Heading from 'components/text/Heading';
import PropTypes from 'prop-types';
import React from 'react';
import ThemeButton from 'components/buttons/ThemeButton';
import styled from 'libs/styled';
import { useSelector } from 'react-redux';

const Wrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

const EmptyBasket = ({ closeBasket }) => {
    const { buttons, emptyLabel } = useSelector(
        state => state.header.data.basket,
        (prev, next) =>
            prev.header?.data.basket.emptyLabel !== next.header?.data.basket.emptyLabel ||
            prev.header?.data.basket.buttons !== next.header?.data.basket.buttons
    );

    return (
        <Wrapper>
            <div>
                <Heading maxWidth="83.33%">{emptyLabel}</Heading>
                {buttons?.emptyBasket && (
                    <ThemeButton
                        mt={['16px', null, '24px']}
                        theme="outlinedBlack"
                        to={buttons.emptyBasket.to}
                        onClick={() => closeBasket()}
                    >
                        {buttons.emptyBasket.label}
                    </ThemeButton>
                )}
            </div>
            <CloseBig cursor="pointer" onClick={() => closeBasket()} />
        </Wrapper>
    );
};

EmptyBasket.propTypes = {
    closeBasket: PropTypes.func.isRequired,
};

export default EmptyBasket;
